import styled from '@emotion/styled'
import { Button } from 'components/button/Button'
import { Spinner } from 'components/spinner/Spinner'
import { colors } from 'utils/colors'
import { BREAKPOINTS, pxToRem } from 'utils/styled'

export const SLifeStoriesBanners = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 1.5rem;

  @media ${BREAKPOINTS.LG.max} {
    display: flex;
    overflow-x: scroll;
    padding: 1.25rem 1rem;
  }
`

export const SBanner = styled.div`
  width: 100%;
  box-shadow: var(--card-shadow);

  position: relative;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 1.5rem;
  padding: 1.25rem;
  align-items: center;

  @media ${BREAKPOINTS.LG.max} {
    min-width: ${pxToRem(315)}rem;
  }
`

export const STextContainer = styled.div``

export const SBannerContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

export const SBannerGallery = styled.div`
  position: relative;
`

export const SUploadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 24px;
  & > div {
    margin-bottom: 1rem;
  }

  @media ${BREAKPOINTS.MD.max} {
    min-height: auto;
  }
`

export const SUploadImagePreview = styled.img`
  width: 72px;
  height: 72px;
  object-fit: cover;
  margin-bottom: 1rem;
`

export const SButton = styled(Button)`
  width: min-content;
  margin-top: 0.5rem;
`

export const SSpinner = styled(Spinner)`
  color: ${colors.blue[500]} !important;
`
